/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Grade_Is_BrokenInputs */

const vi_tea_grade_is_broken = /** @type {(inputs: Tea_Grade_Is_BrokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chè tấm`)
};

/**

* @param {Tea_Grade_Is_BrokenInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_grade_is_broken = /** @type {((inputs?: Tea_Grade_Is_BrokenInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Grade_Is_BrokenInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_grade_is_broken(inputs)
});